export const NODE_TYPES = {
    START: 'start',
    END: 'end',
    ACTION: 'action',
    CONDITION: 'condition',
    FILTER: 'filter',
    USERCHOICE: 'user-choice',
    TASK: 'Task', // at some places it is 'task'. Need to check while implementing
    NESTED: 'nested',
    RUNBOOK: 'runbook'
}